<template>
  <!--<p>MIA Data</p>-->
  <svg width="20" height="20" v-if="lowData">
    <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
  </svg>

  <!--<p>Needs more data</p>-->
  <svg width="20" height="20" v-else-if="mediumData">
    <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
    <path d="M 17 10 A 1 1 1 0 1 3 10" fill="black" />
  </svg>

  <!--<p>Good data quality</p>-->
  <svg width="20" height="20" v-else-if="goodData">
    <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
    <circle cx="10" cy="10" r="6" stroke-width="1" stroke="black" fill="black" />
  </svg>

  <!--<p>No data</p>-->
  <svg width="20" height="20" v-else-if="notApplicable">
    <line x1="1" x2="19" y1="10" y2="10" stroke-width="3" stroke="black"/>
  </svg>

</template>
<script>
export default {
  name: 'data-availability-indicator',
  props: ['score'],
  computed: {
    'notApplicable': function () {
      return this.score === 0 || this.score === "0"
    },
    'lowData': function () {
      return this.score === 1 || this.score === "1"
    },
    'mediumData': function () {
      return this.score === 2 || this.score === "2"
    },
    'goodData': function () {
      return this.score === 3 || this.score === "3"
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// DataAvailabilityIndicator.vue?b8876862